import React from "react";
import styles from "./Factoid.module.scss";
const Factoid = (props) => {
  const {color, title, text, link, size} = props;
  let classWrap = `${styles.wrap}`;
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    classWrap += ` ${styles[`wrap_${color}`]}`;
  }
  if (size !== undefined && styles[`wrap_${size}`] !== undefined) {
    classWrap += ` ${styles[`wrap_${size}`]}`;
  }
  let titleSpan = null;
  let titleSpanPre = null;
  if(title[1] !== undefined && title[1] !== ''){
    titleSpan = <span>{title[1]}</span>;
  }
  if(title[2] !== undefined && title[2] !== ''){
    titleSpanPre = <span className={styles.pretitle}>{title[2]} </span>;
  }
  let linkElement = null;
  if(link !== undefined && link.length > 0){
    linkElement = <a href={link[1]} target='_blank' rel="noreferrer">{link[0]}</a>;
  }
  return (
    <>
      <div className={classWrap}>
        <div className={styles.header}>
          <div className={styles.icon}></div>
          <div className={styles.title}>{titleSpanPre}{title[0]} {titleSpan}</div>
        </div>
        <div className={styles.text}>
          {text}{linkElement}
        </div>
      </div>
    </>
  );

}

export default Factoid;
